import { ResponseSchemaVersion } from "../types/risk-and-gap";
import { convertSnakeToCapitalized } from "./snake-to-capital";

export const getFieldTitle = (key: string, version?: ResponseSchemaVersion) => {
  switch (key) {
    case "assessment_approach_presentation":
      return "Assessment Approach";
    case "sources":
      return version === "v2" ? "Other Reference(s)" : "References";
    case "ultimate_risk":
      return "Ultimate Risk in Question";
    case "research":
      return "Results";
    case "current_maturity_level_value":
      return "Maturity Score"; 
    case "current_maturity_level":
      return "Current Maturity Level";
    case "testing_procedures":
      return "Testing Details";
    case "additional_information": 
    return "Comment";
    default:
      return convertSnakeToCapitalized(key);
  }
};